import React, { useState } from "react";
import moment from "moment";
import Calendar from "react-calendar";
import SimpleModal from "../../components/UI/Modals/SimpleModal/SimpleModal";
import Button from "../../components/UI/Buttons/Button/Button";
import styles from "./DeliveryHistoryPage.module.scss";

interface DateFilterModalProps {
  initialDateFrom: string;
  initialDateTo: string;
  onApply: (from: string, to: string) => void;
  onCancel: () => void;
}

const DateFilterModal: React.FC<DateFilterModalProps> = ({
  initialDateFrom,
  initialDateTo,
  onApply,
  onCancel,
}) => {
  const [dateRange, setDateRange] = useState<[Date, Date]>([
    new Date(initialDateFrom),
    new Date(initialDateTo),
  ]);

  const handleDateChange = (val: any) => {
    if (val && Array.isArray(val)) {
      setDateRange([val[0], val[1]]);
    }
  };

  const handleApply = () => {
    onApply(
      moment(dateRange[0]).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
      moment(dateRange[1]).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    );
  };

  return (
    <SimpleModal
      className={styles.dateFilterModal}
      backdropClickHandler={onCancel}
      show={false}
    >
      <div className={styles.segment}>
        <div className={styles.header}>Period</div>
        <Calendar
          selectRange={true}
          returnValue="range"
          value={dateRange}
          onChange={handleDateChange}
          maxDate={new Date()}
          locale="sr"
          className={styles.calendarWrap}
        />
      </div>
      <Button buttonType="blue" onClick={handleApply}>
        Primeni
      </Button>
    </SimpleModal>
  );
};

export default DateFilterModal;
